import { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { gameActions } from '../../action/GameAction';
import { history } from '../../helpers/history';
import { commonClass } from '../../helpers/commonClass';
class LatestResults extends Component {
    constructor(props) {
        super(props);
        this.props.GetLatestResult(0, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        this.state = {
            VideoSecion: [],
            dataLoadCompleted: false
        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            // latestResult: props.latestResult
            latestResult: props.latestResult && props.latestResult.map(function (ele) {
                return { ...ele, game_group_id_temp: ele.game_group_id == 12 || ele.game_group_id == 8 ? '9' : ele.game_group_id };
            })
        }
    }

    componentDidMount() {
        this.setjsonvideourl();

    }
    componentDidUpdate(prevState, prevProps) {
        if (this.state.dataLoadCompleted == false && this.state.latestResult && this.state.latestResult.length > 0) {
            this.state.dataLoadCompleted = true;
            // setTimeout(() => { 
            //     if (window.LatesResultSlide) {
            //         window.LatesResultSlide();
            //     }
            // }, 0);
            setTimeout(() => {
                window.SetBgimgbasedOnGame();
            }, 1000);
        }
    }
    GotoPreviourresult = (GameId) => {
        localStorage.setItem('drawtabId', 1);
        //GameId == 9 ? history.push('/fortune4draws') : GameId == 10 ? history.push('/super6draws') : history.push('/magic5draws');
        commonClass.IDPageControlDraws(GameId)
    }

    setjsonvideourl = () => {
        let hbanner = 0;
        let hbanner_old = localStorage.getItem('videovers');
        if (this.props.appvariables.bVersion) {
            let hbannerVer = this.props.appvariables.bVersion.split("~")
            if (hbannerVer.length > 0) {
                hbanner = hbannerVer[4];
                localStorage.setItem('videovers', hbanner);
            }
        }
        if (hbanner_old != hbanner) {
            var s = process.env.REACT_APP_CDN_URL + 'web/HomeWinnerVideo.json' + "?V" + hbanner;
            fetch(s).then(response => response.json()).then(data => {
                localStorage.setItem('videourl', JSON.stringify(data));
                this.setState({ VideoSecion: data })
                console.log("data video url", data)
                setTimeout(() => {
                    if (window.HomePageVideoSlider)
                        window.HomePageVideoSlider()
                }, 300);
            })
        } else {
            let Videourl = JSON.parse(localStorage.getItem('videourl'));
            this.setState({ VideoSecion: Videourl })
            console.log("data video url", Videourl)
            // alert('fetch')
            setTimeout(() => {
                if (window.HomePageVideoSlider)
                    window.HomePageVideoSlider()
            }, 300);
        }
    }

    latseresult = (Val, Obj) => {
        console.log('Value', Val)
    }


    render() {
        const { t } = this.props;
        let _ggidLst = []
        if (this.props.lottoType) {
            _ggidLst = [this.props.lottoType];
        }
        else {
            _ggidLst = this.state.latestResult && [...new Set(this.state.latestResult.map(item => item.game_group_id))];
        }
        return (
            <>
                {_ggidLst && _ggidLst.length > 0 && <div>
                    <h2 className="headding1">{t('lblLatestDrawRes')}</h2>
                    <div className="latestDrawRslt">
                        <ul>
                            <li>
                                <div class="w-20 head">{t('lblGames')}</div>
                                <div class="w-20 head">{t('lbldate')}</div>
                                <div class="w-50 head">{t('lbldrawresult')}</div>
                            </li>
                            {_ggidLst && _ggidLst.map((gx, ginxd) => <>{
                                this.state.latestResult && this.state.latestResult.filter(a => a.game_group_id == gx).slice(0, 1).map((x, inxd) =>
                                    <li key={`bg_${inxd}_${ginxd}_${gx}`} id={`game${gx == 8 ? '9' : gx}`} class={`lto-${x.game_group_id}1`}>
                                        <>
                                            <div class={`w-20 gameName lto-${x.game_group_id_temp}-text-color`}>{x.draw_no}</div>
                                            <div class="w-20 date">{x.draw_date.replace('|', ' ')}</div>
                                            <div class="w-40 date">
                                                {x.win_nods && x.win_nods.split(';').map((r, ine) =>
                                                    <div key={`h_${ine}_a${inxd}${r}`} class={`lottoRsltBalls  lto-${x.game_group_id_temp}-bg-color`}>{r}</div>
                                                )}</div>
                                            <div className="w-20">
                                                {/* {x.draw_time && !x.draw_time.startsWith("1~") && <span class={`txt-color-game${x.game_group_id_temp}`}>{x.draw_time}</span>} */}
                                                {x.draw_time && x.draw_time.startsWith("1~") &&
                                                    // <div className="winrAmntDetls">
                                                    //     <table className="tble">
                                                    //         <tbody>
                                                    //             <tr>
                                                    //                 <th>{t('lblWinnings')}({this.props.appvariables.currency})</th>
                                                    //                 <th >{t('lblWinnersml')}</th>
                                                    //             </tr>

                                                    //             {x.draw_time.split('|').map((w, i) =>
                                                    //                 <tr key={`j_${i}_c${inxd}`}>
                                                    //                     <td>{commonClass.aedCrnyConvert(w.split(',')[0])}</td>
                                                    //                     <td>{w.split(',')[1]}</td>
                                                    //                 </tr>
                                                    //             )}

                                                    //         </tbody>
                                                    //     </table>
                                                    // </div>
                                                    // :
                                                    x.draw_time && x.draw_time.startsWith("1~") &&
                                                    <div className="w-full h-48 flex justify-center items-center rounded-2xl text-xl bg-white mt-5">
                                                        <p className={`text-game${x.game_group_id_temp}`}>{t('lblresultprogress')}</p>
                                                    </div>
                                                    // :
                                                    // <div className="w-full h-48 flex justify-center items-center rounded-2xl text-xl bg-white mt-5">
                                                    //     <p className={`text-game${x.game_group_id_temp}`}>{t('lblNoWinner')}</p>
                                                    // </div>
                                                }
                                            </div>


                                            <div onClick={() => { this.GotoPreviourresult(x.game_group_id) }} class="w-10 winBtn">
                                                <a class={`txt-color-game${x.game_group_id} border-color-game${x.game_group_id}`}>{t('lblWinner')}</a>
                                            </div>
                                        </>
                                    </li>
                                )
                            }</>)}
                        </ul>
                    </div>
                    {/* </div>

                </section> */}
                </div>}
            </>
        )
    }

}

function mapStateToProps(state) {
    const { latestResult } = state.gameReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, latestResult, appvariables };
}
const mapActionToProps = {
    GetLatestResult: gameActions.GetLatestResult
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(LatestResults))

